document.addEventListener('DOMContentLoaded', function() {

  const imageWrappers = document.querySelectorAll('.multicolumn-card__image-wrapper[data-link]');

  imageWrappers.forEach(function(imageWrapper) {
    const linkUrl = imageWrapper.getAttribute('data-link');

    if (linkUrl) {
      imageWrapper.classList.add('multicolumn-card__image-wrapper--clickable');

      imageWrapper.addEventListener('click', function(e) {
        window.location.href = linkUrl;
      });
    }
  });
});
